var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.546,
    height: 12.718,
    viewBox: "0 0 11.546 12.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(-4 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4954",
    "data-name": "Path 4954",
    d: "M5.672,6h8.2a1.085,1.085,0,0,1,1.172.969v6.78a1.085,1.085,0,0,1-1.172.969h-8.2A1.085,1.085,0,0,1,4.5,13.749V6.969A1.085,1.085,0,0,1,5.672,6Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4955",
    "data-name": "Path 4955",
    d: "M24,3V9",
    transform: "translate(-11.883)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4956",
    "data-name": "Path 4956",
    d: "M12,3V9",
    transform: "translate(-4.571)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4957",
    "data-name": "Path 4957",
    d: "M4.5,15H15.046",
    transform: "translate(0 -7.313)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f4ef8249a7f795d25309e39d9f0e14c6.svg";
export { ForwardRef as ReactComponent };